/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {

	// JSON取得用 =========================================================
	let categoryList = [];
	let tagList = [];
	let newsList = [];

	let page = 1;
	let perPage = 12;
	let total = 0;
	let totalPage = 0;

	const categoriesJson = (_lang = '') => `/ajax/${_lang ? _lang + '/' : ''}story/category/list.json`;
	const tagsJson = (_lang = '') => `/ajax/${_lang ? _lang + '/' : ''}story/tag/list.json`;
	const newsJson = (_lang) => `/ajax/${_lang ? _lang + '/' : ''}story/list.json`;

	let $path = window.location.pathname;
	const isEnglishPage = () => $path.startsWith('/english');

	const categoriesJpJson = () => `/ajax/story/category/list.json`;
	const tagsJpJson = () => `/ajax/story/tag/list.json`;
	const newsJpJson = () => `/ajax/story/list.json`;
	const categoriesEnJson = () => `/ajax/english/story/category/list.json`;
	const tagsEnJson = () => `/ajax/english/story/tag/list.json`;
	const newsEnJson = () => `/ajax/english/story/list.json`;

	const tagsKey = 'rt_bn_tags';
	const categoryKey = 'rt_bn_category';
	const newsKey = 'rt_bn_news';
	const newsListSelector = '.mod-news-list';

	const categoryAll = () => isEnglish() ? 'All' : 'すべて';
	const getCategoryTag = (category) => {
		return categoryList.find((ele) => {
			return ele.label === category;
		})?.key || '';
	}

	const getCategoryLabel = (category) => {
		return categoryList.find((ele) => {
			return ele.key === category;
		})?.label || '';
	}

	const tagCategoryAll = () => isEnglish() ? 'All' : 'すべて';
	// ====================================================================
	// <ニュース一覧>JSON取得
	const getJson = async (lang, tagsKey, newsKey) => {
		const { categoryList, tagList, newsList } = await Promise.all([
			fetch(isEnglishPage() ? categoriesEnJson() : categoriesJpJson()).then(res => res.json()),
			fetch(isEnglishPage() ? tagsEnJson() : tagsJpJson()).then(res => res.json()),
			fetch(isEnglishPage() ? newsEnJson() : newsJpJson()).then(res => res.json()),
		]).then(([categoryList, tagList, newsList]) => {
			const parsedCategoryList = (categoryList[categoryKey] || []).map((category) => {
				return {
					key: category.cf_nc_code || category.cf_nc_code_en || '',
					label: category.cf_nc_name || category.cf_nc_name_en || '',
				}
			});
			parsedCategoryList.unshift({ key: '', label: categoryAll() });


			const parsedTags = (tagList[tagsKey] || []).map((tag) => {
				return {
					category: tag.cf_nt_category || tag.cf_nt_category_en || '',
					key: tag._key || '',
					label: tag.cf_nt_name_d || tag.cf_nt_name_d_en || '',
				}
			});
			parsedTags.unshift({ category: '', key: '', label: tagCategoryAll() });


			const parsedNews = (newsList[newsKey] || []).map((news) => {
				const getTitleFunc = (key, isSubtitle = false) => {
					const subTitlePrefix = isSubtitle && news[key]?.content ? ' ' : '';

					return subTitlePrefix + (news[key]?.content || []).map((content) => {
						if (typeof content === 'string') {
							return content;
						} else if (typeof content === 'object') {
							if (content.tag) {
								const elem = document.createElement(content.tag);
								return elem.outerHTML;
							}
							return '<br>';
						}
						return '';
					}).join('');
				}

				return {
					category: (news.rt_cf_n_category_name?.content || []).join(''),
					// isPdf: news?.rt_cf_n_attachment_file_icon_pdf !== null,
					isNew: news?.rt_cf_n_icon_new !== null,
					// fileSize: bytesToSize(news.rt_cf_n_attachment_file_size?.content || 0),


					title: getTitleFunc('rt_cf_n_title') + getTitleFunc('rt_cf_n_sub_title', true),

					link: news.rt_cf_n_href_innovationstory?.href || '',
					target: news.rt_cf_n_href_innovationstory?.target || '_self',
					linkStyle: news.rt_cf_n_href_innovationstory?.style || '',
					linkClassList: (news.rt_cf_n_href_innovationstory?.class || '').split(' '),
					date: news.rt_cf_n_date?.content || '',
					year: (news.rt_cf_n_date?.datetime || '').slice(0, 4),
					tags: (news.cf_n_tags || [])
						.filter((tag) => {
							return tag.rt_cf_n_tags_innovationstory !== null;
						}).map((tag) => {
							return {
								key: tag?._key || '',
								label: tag.rt_cf_n_tags_innovationstory?.content || '',
								href: tag.rt_cf_n_tags_innovationstory?.href || '',
							}
						}),
					dt: new Date(news.rt_cf_n_date?.datetime || '9999-12-31'),

					img: news.rt_cf_n_thum_img?.src || '',
					imgAlt: news.rt_cf_n_thum_img?.alt || '',
					imgTitle: news.rt_cf_n_thum_img?.title || '',
				}
			});

			parsedNews.sort((a, b) => {
				return b.dt - a.dt;
			});
			return {
				categoryList: parsedCategoryList,
				tagList: parsedTags,
				newsList: parsedNews,
			};
		});

		return { categoryList, tagList, newsList };
	}

	const getFilteredNewsList = (newsList) => {
		const limit = getLimit();
		const searchParams = new URLSearchParams(window.location.search);
		const pCategory = searchParams.get('p_category') || '';
		const pTagList = searchParams.getAll('p_tag') || [];


		const filteredNewsList = newsList
			.filter((news) => {
				// categories
				const category = getCategoryLabel(pCategory);
				return category && category !== categoryAll() ? news.category === category : true;
			})
			.filter((news) => {
				// tags
				return news.tags.some((tag) => {
					const filteringPTags = pTagList.filter((pTag) => (pTag !== ''));

					if (filteringPTags.length === 0) {
						return true;
					}

					let ret = true;
					filteringPTags.forEach((pTag) => {
						if (!news.tags.find((tag) => tag.key === pTag)) {
							ret = false;
						}
					});

					return ret;
				}) || (pTagList.length === 0 && news.tags.length === 0);
			})
			.filter((news) => {
				// year
				return searchParams.get('p_year') ? news.year === searchParams.get('p_year') : true;
			})
			.filter((news, idx) => {
				// limit
				return limit ? idx < limit : true;
			})
			.filter((news, idx) => {
				// page
				return idx < page * perPage;
			});

		totalPage = Math.ceil(filteredNewsList.length / perPage);

		return filteredNewsList;
	}

	// Lang ==============================================================
	const getLang = () => {
		return window.location.pathname.startsWith('/english/')
			? 'english'
			: '';
	}

	const isEnglish = () => {
		return getLang() === 'english';
	}

	// limit ==============================================================
	const getLimit = () => {
		let limit = null;
		// if (['/', '/index.html', '/english/', '/english/index.html'].includes(window.location.pathname)) {
		// 	limit = 3;
		// } else if (['/ir/', '/ir/index.html', '/english/ir/', '/english/ir/index.html'].includes(window.location.pathname)) {
		// 	limit = 10;
		// } else if (['/news/', '/news/index.html', '/english/news/', '/english/news/index.html'].includes(window.location.pathname)) {
		// 	const pYear = new URLSearchParams(window.location.search).get('p_year') || '';
		// 	if (pYear === '') {
		// 		limit = 30;
		// 	}
		// }

		return limit;
	}

	// Generate Elements ==============================================================
	const generateNewsElement = (news, newsIdx) => {
		const newsElement = document.createElement('li');


		newsElement.classList.add('mod-news-list-item', 'is-visible');

		newsElement.innerHTML = `
			<!-- .mod-hover_img -->
			<a href="" target="" class="mod-hover_img">

			  <!-- .mod-news-new -->
				<p class="mod-news-new __bg_orange di_none">NEW</p>

				<figure class="__img">
					<!-- .__img img -->
					<img src="" alt="" class="width-u-100">
				</figure>
				<div class="mt32 sp_mt0">
					<div class="mod-news-list-item-top_txt">

						<p class="mod-news-list-item-top_txt-day">
							<!-- .mod-news-list-item-top_txt-day -->
						</p>

						<p class="mod-label">
							<!-- .mod-news-list-item-top_txt .mod-label -->
						</p>
					</div>


					<h3 class="mod-news-list-item-title mt24 sp_mt5">
						<!-- .mod-news-list-item-title -->
					</h3>
				</div>
			</a>

			<ul class="mod-pick-label-tag mod-spacer-24_20">
				<!-- .mod-pick-label-tag -->
			</ul>
		`

		// ニュース詳細リンク
		newsElement.querySelector('.mod-hover_img').href = news.link;
		newsElement.querySelector('.mod-hover_img').target = news.target;
		newsElement.querySelector('.mod-hover_img').style = news.linkStyle;
		news.linkClassList.forEach((className) => {
			if (className) {
				newsElement.querySelector('.mod-news-list-item-title').classList.add(className);
			}
		});

		// NEW アイコン
		if (news.isNew) {
			newsElement.querySelector('.mod-news-new').classList.remove('di_none');
		}

		// 画像
		if (news.img) {
			newsElement.querySelector('.__img img').src = news.img;
		}
		if (news.imgAlt) {
			newsElement.querySelector('.__img img').alt = news.imgAlt;
		}
		if (news.imgTitle) {
			newsElement.querySelector('.__img img').title = news.imgTitle;
		}

		// 年月日
		newsElement.querySelector('.mod-news-list-item-top_txt-day').textContent = news.date;

		// カテゴリ
		if (news.category) {
			newsElement.querySelector('.mod-news-list-item-top_txt .mod-label').textContent = news.category;
		}

		// タイトル
		newsElement.querySelector('.mod-news-list-item-title').innerHTML = news.title;


		// タグ
		news.tags.forEach((tag) => {
			const tagElement = document.createElement('li');
			tagElement.innerHTML = `
				<a href="">
						<p class="mod-label-tag"></p>
				</a>
			`;
			tagElement.querySelector('.mod-label-tag').textContent = tag.label;
			tagElement.querySelector('a').href = tag.href;
			newsElement.querySelector('.mod-pick-label-tag').appendChild(tagElement);
		});

		return newsElement;
	}

	const generateCategoryElement = (category) => {
		const categoryElement = document.createElement('div');
		categoryElement.classList.add('mod-news-tab-item');

		categoryElement.innerHTML = `
			<button class="js-category" data-code=""></button>
		`;

		const url = new URL(window.location.href);
		const currentPcategory = new URLSearchParams(window.location.search).get('p_category') || '';
		url.searchParams.set('p_category', category.key);
		const href = url.pathname + url.search;

		categoryElement.querySelector('button').textContent = category.label;
		categoryElement.querySelector('button').dataset.code = category.key;

		if (currentPcategory === category.key) {
			categoryElement.classList.add('current');
		}

		return categoryElement;
	}

	const generateTagsElement = (tag) => {
		const tagElement = document.createElement('a');
		tagElement.classList.add('mod-tag');

		const url = new URL(window.location.href);
		const currentPtag = url.searchParams.getAll('p_tag') || [];
		url.searchParams.set('p_tag', tag.key);

		const href = url.pathname + url.search;

		tagElement.textContent = tag.label;
		tagElement.href = href;
		tagElement.dataset.code = tag.key;

		if (!tag.key) {
			if (currentPtag.length === 0) {
				tagElement.classList.add('current');
			} else if (currentPtag.length === 1 && currentPtag[0] === '') {
				tagElement.classList.add('current');
			}
		} else if (currentPtag.includes(tag.key)) {
			tagElement.classList.add('current');
		}

		if (!tag.key) {
			tagElement.classList.add('mod-tag-all');
		}

		return tagElement;
	}

	const appendNewsElements = (newsList) => {
		const newsListElement = document.querySelector(newsListSelector);
		newsListElement.innerHTML = '';

		if (newsListElement) {
			if (newsList.length === 0) {
				const elem = document.createElement('div');
				// <div class="mod-news-txt-list-item-top">
				elem.classList.add('mod-news-txt-list-item', 'mod-spacer-32_24');
				elem.textContent = isEnglish() ? 'There is no corresponding article.' : '該当する記事はございません。';
				newsListElement.appendChild(elem);
			} else {
				let count = 0;
				newsList.forEach((news, newsIdx) => {
					const elem = generateNewsElement(news, newsIdx);
					if($path.indexOf('/detail/') !== -1) {
						if($path !== news.link) {
							count += 1;
							if(count <= 3) {
								newsListElement.appendChild(elem);
							}
						}
					} else {
						newsListElement.appendChild(elem);
					}
				});
			}
		}

		const listMore = document.querySelector('.js-listMore');
		if (listMore && page >= totalPage) {
			listMore.classList.add('di_none');
		}
	}

	const appendCategoriesElements = (categoryList) => {
		const categoriesElement = document.querySelector('.mod-news-tab-wrap .mod-news-tab');
		if (categoriesElement) {
			categoriesElement.innerHTML = '';

			categoryList.forEach((category) => {
				categoriesElement.appendChild(generateCategoryElement(category));
			});
		}
	}

	const appendTagsElements = (tagList) => {
		const tagsElement = document.querySelector('.mod-news-tag-wrap .mod-news-tag');
		if (tagsElement) {
			tagsElement.innerHTML = '';
			tagList.forEach((tag) => {
				tagsElement.appendChild(generateTagsElement(tag));
			});
		}
	}

	const setCurrentCategory = () => {
		const searchParams = new URLSearchParams(window.location.search);
		const pCategory = searchParams.get('p_category') || '';

		document.querySelectorAll('.mod-news-tab-item button').forEach((node) => {
			if (node.dataset.code === pCategory) {
				node.parentElement.classList.add('current');
			} else {
				node.parentElement.classList.remove('current');
			}
		});

	}


	// init ==============================================================
	const addEventListener = () => {
		const tagsElements = document.querySelectorAll('.mod-news-tag-wrap .mod-news-tag .mod-tag');
		if (tagsElements) {
			const tagEvent = (e) => {
				e.preventDefault();
				const url = new URL(window.location.href);


				if (e.target.classList.contains('mod-tag-all')) {
					url.searchParams.set('p_tag', '');
				} else {
					const targetTag = e.target.dataset.code;
					const currentTags = url.searchParams.getAll('p_tag');
					if (currentTags.includes(targetTag)) {
						url.searchParams.delete('p_tag');
						currentTags.filter((tag) => tag !== targetTag).forEach((tag) => {
							url.searchParams.append('p_tag', tag);
						});
					} else {
						url.searchParams.append('p_tag', targetTag);
					}
				}

				// const targetUrl = new URL(e.target.href);
				// url.searchParams.set('p_tag', targetUrl.searchParams.get('p_tag') || '');

				// push state
				window.history.pushState({}, '', url.search);

				initHtml();
			};

			tagsElements.forEach((node) => {
				node.removeEventListener('click', tagEvent);
				node.addEventListener('click', tagEvent);
			});
		}

		const categoriesElements = document.querySelectorAll('.mod-news-tab-item');
		if (categoriesElements) {
			const categoryEvent = (e) => {
				e.preventDefault();

				const text = e.target.textContent;
				const category = getCategoryTag(text);

				const url = new URL(window.location.href);
				url.searchParams.set('p_category', category);
				url.searchParams.delete('p_tag');

				// push state
				window.history.pushState({}, '', url.search);
				initHtml();
			};

			categoriesElements.forEach((node) => {
				node.removeEventListener('click', categoryEvent);
				node.addEventListener('click', categoryEvent);
			});
		}

		const yearListElement = document.querySelector('.js-news-yearList');
		if (yearListElement) {
			const yearListEvent = (e) => {
				const url = new URL(window.location.href);
				url.searchParams.set('p_year', e.target.value);

				// push state
				window.history.pushState({}, '', url.search);
				initHtml();
			};

			yearListElement.removeEventListener('change', yearListEvent);
			yearListElement.addEventListener('change', yearListEvent);
		}
	}

	const initHtml = () => {
		// カテゴリー
		appendCategoriesElements(categoryList);
		setCurrentCategory();

		// タグ
		appendTagsElements(tagList);

		// ニュース
		const filteredNewsList = getFilteredNewsList(newsList);
		appendNewsElements(filteredNewsList);

		// Event Listener
		addEventListener();


		// const listMoreElement = document.querySelector('.js-listMore');
		// if (listMoreElement) {
		// 	if (page >= totalPage) {
		// 		listMoreElement.classList.add('di_none');
		// 	}
		// }
	}

	const init = async () => {
		const lang = getLang();
		const jsonData = await getJson(lang, tagsKey, newsKey);

		categoryList = jsonData.categoryList || [];
		tagList = jsonData.tagList || [];
		newsList = jsonData.newsList || [];

		total = newsList.length;
		totalPage = Math.ceil(total / perPage);

		initHtml();


		const listMoreElement = document.querySelector('.js-listMore');
		if (listMoreElement) {
			const listMoreEvent = (e) => {
				e.preventDefault();

				page = page + 1;
				initHtml();
				addEventListener();

				if (page >= totalPage) {
					listMoreElement.classList.add('di_none');
				}
			};

			listMoreElement.removeEventListener('click', listMoreEvent);
			listMoreElement.addEventListener('click', listMoreEvent);
		}
	}


	init();
})(window.FUNCTIONS);
